export default __webpack_public_path__ + "static/media/hero-d.17177cba.jpg";